import React from 'react';

const LoadingSpinnerSmaller = () => {
  const wrapperStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };

  const spinnerStyle = {
    display: 'inline-block',
    width: '20px', // Reduzido para o tamanho de um botão
    height: '20px', // Reduzido para o tamanho de um botão
  };

  const circleStyle = {
    display: 'block',
    width: '100%', // O círculo agora se adapta ao tamanho do spinner
    height: '100%', // O círculo agora se adapta ao tamanho do spinner
    border: '3px solid rgb(16, 71, 133)', // Mantido proporcional
    borderRadius: '50%',
    borderColor: '#333 transparent transparent transparent',
    animation: 'spin 1.2s linear infinite',
  };

  return (
    <div style={wrapperStyle}>
      <div style={spinnerStyle}>
        <div style={circleStyle}></div>
      </div>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default LoadingSpinnerSmaller;
